"use client";

import { Suspense } from "react";
import dynamic from "next/dynamic";
import { VerifiedEmailToastLogic } from "@/app/new-home/old-home-page/src/home/VerifiedEmailToastLogic";
import { CustomToast } from "components/utilities/CustomToast";
import { selectAuthUI, selectsoftLoginUI } from "stores/auth/authSlice";
import { useAppSelector } from "stores/hooks";
import { selectUI } from "stores/ui/uiSlice";
const VerifyEmailModal = dynamic(() => import( /* webpackChunkName: "VerifyEmailModal" */"components/login/verify-email/verify-email"), {
  ssr: false
});
const LoginOrSignUpModal = dynamic(() => import( /* webpackChunkName: "LoginOrSignUpModal" */"components/login/login-or-signup-modal"), {
  ssr: false
});
const SoftLoginModal = dynamic(() => import( /* webpackChunkName: "SoftLoginModal" */"components/login/soft-login/SoftLoginModal"), {
  ssr: false
});
const AccountSuspendedModal = dynamic(() => import( /* webpackChunkName: "AccountSuspendedModal" */"components/login/account-suspended-modal"), {
  ssr: false
});
const LoginOrSignUpModalWrapper = () => {
  const {
    modalType
  } = useAppSelector(selectAuthUI);
  return modalType ? <LoginOrSignUpModal key='loginModal' data-sentry-element="LoginOrSignUpModal" data-sentry-component="LoginOrSignUpModalWrapper" data-sentry-source-file="Auth.tsx" /> : null;
};
const VerifyEmailWrapper = () => {
  const {
    isVerifyEmailModalOpen
  } = useAppSelector(selectAuthUI);
  return isVerifyEmailModalOpen ? <VerifyEmailModal data-sentry-element="VerifyEmailModal" data-sentry-component="VerifyEmailWrapper" data-sentry-source-file="Auth.tsx" /> : null;
};
const SoftLoginWrapper = () => {
  const {
    softLoginType
  } = useAppSelector(selectsoftLoginUI);
  return softLoginType ? <SoftLoginModal data-sentry-element="SoftLoginModal" data-sentry-component="SoftLoginWrapper" data-sentry-source-file="Auth.tsx" /> : null;
};
const CustomToastWrapper = () => {
  const {
    toastData
  } = useAppSelector(selectUI);
  return toastData ? <CustomToast toastData={toastData} data-sentry-element="CustomToast" data-sentry-component="CustomToastWrapper" data-sentry-source-file="Auth.tsx" /> : null;
};
const AccountSuspendedModalWrapper = () => {
  const {
    isSuspendedModalOpen
  } = useAppSelector(selectAuthUI);
  return isSuspendedModalOpen ? <AccountSuspendedModal data-sentry-element="AccountSuspendedModal" data-sentry-component="AccountSuspendedModalWrapper" data-sentry-source-file="Auth.tsx" /> : null;
};
const Auth = () => {
  return <>
      <LoginOrSignUpModalWrapper data-sentry-element="LoginOrSignUpModalWrapper" data-sentry-source-file="Auth.tsx" />
      <VerifyEmailWrapper data-sentry-element="VerifyEmailWrapper" data-sentry-source-file="Auth.tsx" />
      <SoftLoginWrapper data-sentry-element="SoftLoginWrapper" data-sentry-source-file="Auth.tsx" />
      <CustomToastWrapper data-sentry-element="CustomToastWrapper" data-sentry-source-file="Auth.tsx" />
      <AccountSuspendedModalWrapper data-sentry-element="AccountSuspendedModalWrapper" data-sentry-source-file="Auth.tsx" />
      <Suspense data-sentry-element="Suspense" data-sentry-source-file="Auth.tsx">
        <VerifiedEmailToastLogic data-sentry-element="VerifiedEmailToastLogic" data-sentry-source-file="Auth.tsx" />
      </Suspense>
    </>;
};
export default Auth;